import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoHomeOutline } from "react-icons/io5";
import { IoIosLink } from "react-icons/io";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import "./ReviewedApplication.css";
import ENDPOINT_URL from "../../config";

const ReviewerDashboard = () => { 
  const [reviewer, setReviewer] = useState({ username: "", email: "" });
  const [assignedPipelines, setAssignedPipelines] = useState([]);
  const navigate = useNavigate();
 
  useEffect(() => {
    fetchReviewerDetails();
    fetchAssignedPipelines();
  }, []); 

  // ========================== GET REVIEWER DETAILS =========================
const fetchReviewerDetails = async () => { 
  console.log("API Request: GET /api/reviewers/me");

  try {
    const response = await fetch(`${ENDPOINT_URL}/api/reviewers/me`, {
      credentials: "include",
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => null);
      console.error("API Error Response:", errData);
      throw new Error(errData?.error || "Failed to load reviewer details");
    }

    const data = await response.json();

    console.log("API Response Data (Reviewer):", data);

    setReviewer(data);
  } catch (err) {
    console.error("API Error:", err);
    toast.error(err?.message || "Failed to load reviewer details.");
  }
};


  // ========================== GET ASSIGNED PIPELINES ==========================
const fetchAssignedPipelines = async () => {
  console.log("API Request: GET /api/reviewers/assigned/pipelines");

  try {
    const response = await fetch(
      `${ENDPOINT_URL}/api/reviewers/assigned/pipelines`,
      { credentials: "include" }
    );

    if (!response.ok) {
      const errData = await response.json().catch(() => null);
      console.error("API Error Response:", errData);
      throw new Error(errData?.error || "Failed to load pipelines");
    }

    const data = await response.json();

    console.log("API Response Data (Pipelines):", data);

    setAssignedPipelines(data);
  } catch (err) {
    console.error("API Error:", err);
    toast.error(err?.message || "Failed to load pipelines.");
  }
};


  // ========================== LOGOUT ==========================
// const handleLogout = async () => {
//   console.log("API Request: POST /api/logout/reviewer/" + reviewer._id);

//   try {
//     const response = await fetch(
//       `${ENDPOINT_URL}/api/logout/reviewer/${reviewer._id}`,
//       {
//         method: "POST",
//         credentials: "include",
//       }
//     );

//     if (!response.ok) {
//       const errData = await response.json().catch(() => null);
//       console.error("API Error Response (Logout):", errData);
//       throw new Error(errData?.error || "Logout failed");
//     }

//     const data = await response.json().catch(() => null);
//     console.log("API Response Data (Logout):", data);

//     navigate("/reviewer-login");
//   } catch (err) {
//     console.error("API Error (Logout):", err);
//     toast.error(err?.message || "Logout failed.");
//   }
// };
const handleLogout = () => {
  console.log("Reviewer logged out");

  // Clear everything for reviewer
  localStorage.removeItem("reviewer_token");
  localStorage.removeItem("reviewer_info");

  // If you also store other reviewer-related keys, clear them
  // localStorage.removeItem("xyz");

  // Optional: clear all localStorage
  // localStorage.clear();

  // Redirect to login
  window.location.href = "/reviewer-login";
};


  return (
    <div className="dashboard-reviewerdashboard">

      {/* =============== SIDEBAR =============== */}
      <aside className="sidebar-reviewerdashboard">
        <div className="logo-container-reviewerdashboard">
          <img 
            src="/navbar/drishtilogo.jpg"
            alt="Logo"
            className="dristilogo-reviewerdashboard"
          />
        </div>

        <div className="nav-container-reviewerdashboard">
          <nav className="nav-reviewerdashboard">
            <ul>
              {/* <li className="active-reviewerdashboard">
                <Link to="/reviewer/dashboard">
                  <IoHomeOutline className="nav-icon-reviewerdashboard" />
                  Dashboard
                </Link>
              </li> */}

              <li>
                <Link to="/reviewer/pipelines/applicant">
                  <IoIosLink className="nav-icon-reviewerdashboard" />
                   Assigned Application
                </Link>
              </li>
                <li>
                <Link to="/reviewer/pipelines/dashboard">
                    <IoCheckmarkDoneCircleOutline className="nav-icon-reviewerdashboard" />
                    Reviwed Application
                </Link>
                </li>
            </ul>
          </nav>
        </div>
      </aside>

      {/* =============== MAIN CONTENT =============== */}
      <main className="main-content-reviewerdashboard">

        {/* HEADER */}
        <header className="header-reviewerdashboard">
          <span className="founder-reviewerdashboard">Reviewer Dashboard</span>

          <div className="profile-section-reviewerdashboard">
            <div className="user-info-reviewerdashboard">
              <span className="user-initials-reviewerdashboard">
                <img
                  src="/navbar/login.png"
                  alt="Login"
                  style={{ width: "40px" }}
                />
              </span>

              <div className="user-details-reviewerdashboard">
                <span className="user-name-reviewerdashboard">
                  {reviewer.username}
                </span>
                <br />
                <span className="user-email-reviewerdashboard">
                  {reviewer.email}
                </span>
              </div>
            </div>

            <button
              className="logout-button-reviewerdashboard"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </header>

        {/* CARDS SECTION */}
        <section className="content-reviewerdashboard">
       {/* <div className="dashboard-cards-reviewerdashboard"> */}
  {/* Card 1 */}
  {/* <div className="card-reviewerdashboard">
    <h4>Pipelines Assigned</h4>
    <div className="count-reviewerdashboard-numbers">
      {assignedPipelines.length}
    </div>
  </div> */}

  {/* Card 2 (Blank like Homepage second card) */}
  {/* <div className="card-reviewerdashboard">
    <h4>Card 2</h4>
    <div className="count-reviewerdashboard-numbers">—</div>
  </div>
</div> */}


          {/* TABLE SECTION */}
          {/* <div className="table-container-reviewerdashboard">
            <h3 className="heading-reviewerdashboard">Assigned Pipelines</h3>

            <table className="program-table-reviewerdashboard">
              <thead>
                <tr>
                  <th>Pipeline</th>
                  <th>Total Applications</th>
                </tr>
              </thead>

              <tbody>
                {assignedPipelines.length > 0 ? (
                  assignedPipelines.map((p) => (
                    <tr key={p._id}>
                      <td>{p.title}</td>
                      <td>{p.totalApplications || 0}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No pipelines assigned</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> */}
        </section>
      </main>
    </div>
  );
};

export default ReviewerDashboard;